__turbopack_context__.v({
  "description": "UyznNq_description",
  "descriptionButton": "UyznNq_descriptionButton",
  "kit": "UyznNq_kit",
  "media": "UyznNq_media",
  "mediaRow": "UyznNq_mediaRow",
});
